import { render, staticRenderFns } from "./CheckBoxInput.vue?vue&type=template&id=5cb6a390&scoped=true"
import script from "./CheckBoxInput.vue?vue&type=script&lang=js"
export * from "./CheckBoxInput.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxInput.vue?vue&type=style&index=0&id=5cb6a390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6a390",
  null
  
)

export default component.exports